module.exports = __webpack_public_path__ + "img/banshou.645bba1d.png";